import Emitter from "es6-event-emitter";
import { generateCoverURL, labelToDate } from "./../utilities/utils";
import options from "../config";

export default class ContentPackageStore extends Emitter {
  contentPackagesJson = null;

  _apiManager = null;
  _appState = null;
  _locale = "";
  _imageSizes = null;
  _dateFormat = null;
  _options = null;

  constructor(apiManager, appState, locale, imageSizes, dateFormat, options) {
    super();
    if (!locale) {
      throw "locale not defined";
    }
    this._apiManager = apiManager;
    this._appState = appState;
    this._locale = locale;
    this._imageSizes = imageSizes;
    this._dateFormat = dateFormat;
    this._options = options;
  }

  getAllContentPackages() {
    return this.contentPackagesJson;
  }

  loadContentPackages(downloadToken, numberToRetrieve, domain = null) {
    let token = downloadToken;
    if (this._options.downloadToken && this._options.downloadToken !== "") {
      token = this._options.downloadToken;
    }

    this._apiManager
      .getContentPackageList(
        token,
        numberToRetrieve,
        undefined,
        this._appState.userId,
        this._appState.isPreviewUser && options.kiosque.showPreviewPublications
      )
      .then((json) => {
        this.contentPackagesJson = json;
        for (let i = 0; i < this.contentPackagesJson.length; i++) {
          const pub = this.contentPackagesJson[i];
          this.contentPackagesJson[i] = this.normalizePubForSwiper(pub, domain);
        }
        this.trigger("contentPackages:loaded");
      });
  }

  beautifyDate(uglyDate) {
    return labelToDate(uglyDate, this._locale, this._dateFormat);
  }

  normalizePubForSwiper(pub, domain = null) {
    const result = pub;
    if (this._options.useNameAsLabel) {
      result.label = pub.ContentPackageName;
    } else {
      result.label = this.beautifyDate(pub.PublicationDate);
    }
    result.imageUrl = generateCoverURL(
      pub.ContentPackageId,
      this._imageSizes.S,
      pub.ThumbnailId,
      pub.Version,
      domain
    );
    return result;
  }

  /**
   * Returns content package price based on content package id
   * @param  {Integer} cpId content package id
   * @return {Float}        contant package price
   */
  getContentPackagePrice(cpId) {
    const contentPackage = this.contentPackagesJson.find((cp) => {
      return cp.ContentPackageId == cpId; // eslint-disable-line
    });

    if (contentPackage) {
      return contentPackage.StoreProducts[0].Price;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/stores/contentPackageStore.js